export default {
  cancelationContainer: {
    background: '#fff',
    textAlign: 'center',
    padding: '20px',
    '@media(min-width:801px)': {
      padding: '20px 30px'
    }
  },
  customerForm: {
    background: '#fff',
    textAlign: 'center',
    maxWidth: '800px',
    margin: '0 auto'
  },
  mainTitle: {
    font: data => '500 16px ' + data.fontFamily1,
    marginBottom: '20px',
    display: 'block',
    '@media(min-width:801px)': {
      fontSize: '18px',
      margin: '0 10px 10px'
    }
  },
  conditions: {
    fontSize: '11px',
    fontWeight: 'bold',
    marginBottom: '10px',
    '@media(min-width:801px)': {
      fontSize: '13px'
    }
  },
  reservationInfo: {
    marginLeft: '10px',
    fontWeight: '500'
  },
  cancelledId: {
    marginTop: '30px'
  },
  specialInfo: {
    textAlign: 'center'
  },
  paddedText: {
    padding: '0 0 20px',
    display: 'block',
    font: data => '300 13px ' + data.fontFamily1,
    '&$specialInfo': {
      padding: '0'
    }
  },
  goldInfo: {
    fontSize: '13px',
    textAlign: 'left'
  },
  separator: {
    borderTop: '1px solid #d8d8d8',
    paddingTop: '20px',
    '@media(min-width:801px)': {
      borderTop: 'none'
    }
  },
  checkBoxContainer: {
    maxWidth: '600px',
    margin: '30px auto 20px',
    textAlign: 'center',
    '@media(min-width:801px)': {
      borderTop: 'none'
    }
  },
  finalPrice: {
    paddingTop: "20px",
    '@media (min-width: 801px)': {
      paddingTop: "30px"
    }
  },
  cancelationButton: {
    height: "auto",
    width: "auto",
    padding: "0 10px",
    minHeight: "42px",
    minWidth: "177px"
  }
};
